import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiStar, FiPhone, FiNavigation } = FiIcons;

function Hero() {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="liquid-bg"></div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <motion.div
          className="max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <motion.div
            className="glass-card p-8 md:p-12 floating-animation"
            whileHover={{ scale: 1.02 }}
          >
            <motion.h1
              className="text-4xl md:text-6xl font-bold mb-6"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
            >
              Welcome to{' '}
              <span className="text-gradient">Kumarana Hotel</span>
            </motion.h1>
            
            <motion.p
              className="text-xl md:text-2xl mb-8 text-white/90"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
            >
              Superior Bungalow • SLTDA Certified • Gateway to Sabaragamuwa Heritage
            </motion.p>

            <motion.div
              className="flex flex-wrap justify-center gap-4 mb-8"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
            >
              <div className="flex items-center gap-2 glass-card px-4 py-2 rounded-full">
                <SafeIcon icon={FiMapPin} className="text-blue-300" />
                <span className="text-white">Panamure Junction, Main Road</span>
              </div>
              <div className="flex items-center gap-2 glass-card px-4 py-2 rounded-full">
                <SafeIcon icon={FiStar} className="text-yellow-300" />
                <span className="text-white">SLTDA Registered</span>
              </div>
            </motion.div>

            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.8 }}
            >
              <a href="tel:076-8727112" className="btn-glass pulse-glow">
                <SafeIcon icon={FiPhone} />
                Call Now: 076-8727112
              </a>
              <a
                href="https://maps.google.com/?q=Kumarana+Hotel+Panamure"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-glass"
              >
                <SafeIcon icon={FiNavigation} />
                Get Directions
              </a>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>

      <motion.div
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2"></div>
        </div>
      </motion.div>
    </section>
  );
}

export default Hero;